import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { GridOn } from '@material-ui/icons';
import RefreshIcon from '@material-ui/icons/Autorenew';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import { connect } from 'react-redux';
import { CUSTOM_TABLE_FIELD_TYPES, EXTERNAL_CORE_TABLE_TYPES } from '../../_config/consts';
import { GREEN } from '../../_config/consts';
import MDButton from '../MDButton/MDButton';
import SimpleExportMenu from '../ExportMenus/SimpleExportMenu';
import CustomField from '../forms/Fields/CustomField';
import SelectableField from '../forms/Fields/SelectableInput/SelectableField';
import SearchFiltersAccordion from '../Logs/SearchFiltersAccordion';
import * as GuestActions from '../../redux/actions/guest.actions';
import * as LockActions from '../../redux/actions/lock.actions';

const styles = theme => ({
  filtersContainer: {
    marginTop: -10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  filtersGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '15px',
    padding: '10px 0',
    width: '100%',
    alignItems: 'flex-end',
  },
  filtersRowContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    width: '100%',
    gap: '15px',
  },
  filtersGridSection: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: '8px',
    columnGap: '15px',
    flex: 1,
    maxWidth: 'calc(100% - 100px)',
  },
  filterField: {
    minWidth: '220px',
    maxWidth: '220px',
  },
  numericRangeContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0px',
    width: '100%',
  },
  numericRangeField: {
    flex: 1,
    minWidth: '100px',
  },
  dateRangeContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0px',
    width: '100%',
  },
  dateRangeField: {
    flex: 1,
    minWidth: '100px',
  },
});

const getFieldType = (type) => {
  switch (type) {
    case CUSTOM_TABLE_FIELD_TYPES.TEXT:
      return 'text';
    case CUSTOM_TABLE_FIELD_TYPES.INTEGER_NUMBER:
      return 'number';
    case CUSTOM_TABLE_FIELD_TYPES.DECIMAL_NUMBER:
      return 'number';
    case CUSTOM_TABLE_FIELD_TYPES.DATE:
      return 'airbnbDate';
    case CUSTOM_TABLE_FIELD_TYPES.MONETARY:
      return 'number';
    case CUSTOM_TABLE_FIELD_TYPES.EXTERNAL_REFERENCE:
      return 'text';
    default:
      return 'text';
  }
};

const isNumericField = (type) => {
  return type === CUSTOM_TABLE_FIELD_TYPES.INTEGER_NUMBER ||
         type === CUSTOM_TABLE_FIELD_TYPES.DECIMAL_NUMBER ||
         type === CUSTOM_TABLE_FIELD_TYPES.MONETARY;
};

const isDateField = (type) => {
  return type === CUSTOM_TABLE_FIELD_TYPES.DATE;
};

const isExternalReferenceField = (type) => {
  return type === CUSTOM_TABLE_FIELD_TYPES.EXTERNAL_REFERENCE;
};

@connect(state => ({}), dispatch => ({ dispatch }))
class CustomTableFilterHeader extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      usersOptions: [],
      locksOptions: [],
    };
  }

  async onFilterUsers(value) {
    const { dispatch } = this.props;
    try {
      const users = await dispatch(GuestActions.fetchGuestsForSelector(value));
      const options = _.map(users, user => ({ 
        value: user.id, 
        label: `${user.firstname} ${user.lastname} (${user.email})` 
      }));
      this.setState({ usersOptions: options });
      return options;
    } catch (error) {
      console.error('Error fetching users:', error);
      return [];
    }
  }

  async onFilterLocks(value) {
    const { dispatch } = this.props;
    try {
      const response = await dispatch(LockActions.fetchLocks(0, false, 50));
      const locks = response || [];
      const filteredLocks = value ? 
        _.filter(locks, lock => 
          (lock.name && lock.name.toLowerCase().includes(value.toLowerCase())) ||
          (lock.deviceId && lock.deviceId.toLowerCase().includes(value.toLowerCase()))
        ) : locks;
      const options = _.map(filteredLocks, lock => ({ 
        value: lock.id, 
        label: lock.name || lock.deviceId 
      }));
      this.setState({ locksOptions: options });
      return options;
    } catch (error) {
      console.error('Error fetching locks:', error);
      return [];
    }
  }

  onSelectEntity(field, entity) {
    const { onFilterChange } = this.props;
    if (entity && entity.value) {
      onFilterChange(field.name, entity.value);
    }
  }

  onClearExternalReference(field) {
    const { onFilterChange } = this.props;
    onFilterChange(field.name, '');
  }

  renderSingleField = (field) => {
    const { filters, onFilterChange } = this.props;
    
    return (
      <CustomField
        input={{
          value: filters[field.name] || '',
          onChange: (value) => onFilterChange(field.name, value),
          onFocus: () => {},
        }}
        meta={{}}
        type={getFieldType(field.type)}
        placeholder={field.name}
        containerStyle={{ marginBottom: 0 }}
      />
    );
  }

  renderExternalReferenceField = (field) => {
    const { filters } = this.props;
    const { usersOptions, locksOptions } = this.state;

    if (!field.externalCoreTable) {
      return this.renderSingleField(field);
    }

    let options = [];
    let placeholderEntity = 'selectEntity';
    let onInputChange = null;

    switch (field.externalCoreTable) {
      case EXTERNAL_CORE_TABLE_TYPES.USER:
        options = usersOptions;
        placeholderEntity = 'selectUser';
        onInputChange = (value) => this.onFilterUsers(value);
        break;
      case EXTERNAL_CORE_TABLE_TYPES.SMART_LOCK:
        options = locksOptions;
        placeholderEntity = 'selectSmartLock';
        onInputChange = (value) => this.onFilterLocks(value);
        break;
      default:
        return this.renderSingleField(field);
    }

    return (
      <SelectableField
        input={{
          value: filters[field.name] || '',
          onChange: () => {},
        }}
        meta={{}}
        noCache
        options={options}
        onBlur={() => {}}
        placeholder={<Entity entity={placeholderEntity} />}
        onInputChange={onInputChange}
        onSelect={(entity) => this.onSelectEntity(field, entity)}
        containerStyle={{ marginBottom: 0 }}
      />
    );
  }

  renderNumericRangeField = (field) => {
    const { filters, onFilterChange } = this.props;
    const fieldFilter = filters[field.name] || {};

    return (
      <div className={this.props.classes.numericRangeContainer}>
        <div className={this.props.classes.numericRangeField}>
          <CustomField
            input={{
              value: fieldFilter.min || '',
              onChange: (value) => onFilterChange(field.name, { ...fieldFilter, min: value }),
              onFocus: () => {},
            }}
            meta={{}}
            type="number"
            placeholder={`Min. ${field.name}`}
            containerStyle={{ marginBottom: 0 }}
          />
        </div>
        <div className={this.props.classes.numericRangeField} style={{ marginLeft: 10 }}>
          <CustomField
            input={{
              value: fieldFilter.max || '',
              onChange: (value) => onFilterChange(field.name, { ...fieldFilter, max: value }),
              onFocus: () => {},
            }}
            meta={{}}
            type="number"
            placeholder={`Max. ${field.name}`}
            containerStyle={{ marginBottom: 0 }}
          />
        </div>
      </div>
    );
  }

  renderDateRangeField = (field) => {
    const { filters, onFilterChange } = this.props;
    const fieldFilter = filters[field.name] || {};

    return (
      <div className={this.props.classes.dateRangeContainer}>
        <div className={this.props.classes.dateRangeField}>
          <CustomField
            input={{
              value: fieldFilter.min || '',
              onChange: (value) => onFilterChange(field.name, { ...fieldFilter, min: value }),
              onFocus: () => {},
            }}
            meta={{}}
            type="airbnbDate"
            placeholder={`Min. ${field.name}`}
            containerStyle={{ marginBottom: 0, height: '54px' }}
          />
        </div>
        <div className={this.props.classes.dateRangeField} style={{ marginLeft: 10 }}>
          <CustomField
            input={{
              value: fieldFilter.max || '',
              onChange: (value) => onFilterChange(field.name, { ...fieldFilter, max: value }),
              onFocus: () => {},
            }}
            meta={{}}
            type="airbnbDate"
            placeholder={`Max. ${field.name}`}
            containerStyle={{ marginBottom: 0, height: '54px' }}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      classes,
      themeName,
      searchableFields,
      filters,
      onFilterChange,
      onFiltersReset,
      onNewEntity,
      onRefresh,
      onExportElements,
      numberOfElements,
      loading,
    } = this.props;

    const themeClass = `list-view-header bg-${themeName}-theme`;

    const searchFilters = (
      <div className={classes.filtersRowContainer}>
        <div className={classes.filtersGridSection}>
          {_.map(searchableFields, (field, index) => {
            return (
              <React.Fragment key={field.id}>
                <div className={classes.filterField}>
                  {isNumericField(field.type) 
                    ? this.renderNumericRangeField(field)
                    : isDateField(field.type)
                    ? this.renderDateRangeField(field)
                    : isExternalReferenceField(field.type)
                    ? this.renderExternalReferenceField(field)
                    : this.renderSingleField(field)
                  }
                </div>
              </React.Fragment>
            );
          })}
        </div>
        {searchableFields && searchableFields.length > 0 && (
          <div style={{ alignSelf: 'flex-end' }}>
            <MDButton
              fullWidth={false}
              backgroundColor="#D32F2F"
              title={<Entity entity="reset" />}
              onClick={() => onFiltersReset()}
              containerStyle={{ margin: 0, minWidth: '80px' }}
            />
          </div>
        )}
      </div>
    );

    return (
      <div className={themeClass} style={{ width: '100%' }}>
        <div className="r-list-view-header-row" style={{ padding: 0, display: 'flex', marginLeft: 0, alignItems: 'center', flexWrap: 'wrap', rowGap: 8, columnGap: 8, width: '100%' }}>
          <div style={{ marginRight: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
            <GridOn style={{ fontSize: 22 }} />
            <h4 style={{ marginTop: 5 }}>{numberOfElements}</h4>
          </div>

          {searchableFields && searchableFields.length > 0 ? (
            <SearchFiltersAccordion
              containerstyle={{ marginTop: 5, width: 'fit-content', maxWidth: '100%' }}
              primaryFilters={
                <h3 style={{ fontWeight: 'bold', margin: 0, color: 'white' }}>
                  <Entity entity="searchFilters" />
                </h3>
              }
            >
              <div className={classes.filtersContainer}>
                {searchFilters}
              </div>
            </SearchFiltersAccordion>
          ) : null}

          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', columnGap: 8, rowGap: 8, flexShrink: 0 }}>
            {onNewEntity ? (
              <MDButton
                fullWidth={false}
                backgroundColor={GREEN}
                containerStyle={{ margin: 0 }}
                title={<Entity entity="addNewCustomTableRow" />}
                onClick={() => onNewEntity()}
              />
            ) : null}
            {onRefresh ? (
              <IconButton onClick={() => onRefresh()}>
                <RefreshIcon style={{ fontSize: 30, color: 'white' }} />
              </IconButton>
            ) : null}
            {onExportElements ? (
              <SimpleExportMenu
                numberOfElements={numberOfElements}
                onExportLogs={format => onExportElements(format)}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CustomTableFilterHeader);